import { createGlobalStyle } from "styled-components";
import { fontFamily, textColorDark, textColorLight, primaryColor, borderColor, mutedForeground } from "../utils/variables";

export const GlobalStyles: any = createGlobalStyle`
    * {
        outline: none;
        box-sizing: border-box;
    }
    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        overflow-x: hidden; /* Убираем горизонтальный скролл */
    }
    body {
        background-color: ${textColorLight};
        font-family: ${fontFamily};
        color: ${textColorDark};
    }
    a {
        text-decoration: none;
    }

    img.visor-icon-muted,
    .visor-icon-muted img {
        filter: var(--icon-filter-muted);
        opacity: var(--icon-opacity-muted);
        transition: filter 200ms ease, opacity 200ms ease;
    }

    img.visor-icon-muted:hover,
    .visor-icon-muted img:hover {
        filter: var(--icon-filter-hover);
        opacity: var(--icon-opacity-hover);
    }

    #root {
        min-height: 100vh; /* Используем динамическую высоту экрана */
        display: flex;
        flex-direction: column;
        
        @media (max-width: 1200px) {
            min-height: 100dvh; /* Для мобильной версии используем динамическую высоту viewport */
        }
    }

    html.dark .ant-modal-mask {
        backdrop-filter: blur(var(--modal-backdrop-blur)) brightness(var(--modal-backdrop-brightness));
        -webkit-backdrop-filter: blur(var(--modal-backdrop-blur)) brightness(var(--modal-backdrop-brightness));
    }

    .modal-date-picker.ant-picker,
    .ant-picker.modal-date-picker {
        border-color: ${borderColor} !important;
        background: var(--input) !important;
    }

    .modal-date-picker .ant-picker-input > input {
        color: var(--foreground) !important;
    }

    .modal-date-picker .ant-picker-input > input::placeholder {
        color: ${mutedForeground} !important;
    }

    /* InputNumber: текст суммы читаемый и в обычном, и в disabled (фикс. цена) */
    .ant-input-number,
    .ant-input-number-affix-wrapper {
        color: var(--foreground) !important;
        background: var(--card) !important;
    }

    .ant-input-number .ant-input-number-input,
    .ant-input-number-affix-wrapper .ant-input-number-input {
        color: var(--foreground) !important;
        -webkit-text-fill-color: var(--foreground) !important;
        caret-color: var(--foreground);
    }

    .ant-input-number .ant-input-number-input::placeholder,
    .ant-input-number-affix-wrapper .ant-input-number-input::placeholder {
        color: ${mutedForeground} !important;
        -webkit-text-fill-color: ${mutedForeground} !important;
        opacity: 1;
    }

    .ant-input-number-disabled,
    .ant-input-number-affix-wrapper-disabled,
    .ant-input-number-disabled .ant-input-number-input,
    .ant-input-number-affix-wrapper-disabled .ant-input-number-input {
        color: var(--foreground) !important;
        -webkit-text-fill-color: var(--foreground) !important;
        opacity: 0.85 !important;
    }

    .ant-input-number-group-addon {
        color: var(--foreground) !important;
        background: var(--muted) !important;
        border-color: var(--border) !important;
    }

    .ant-input-number-disabled .ant-input-number-group-addon,
    .ant-input-number-affix-wrapper-disabled + .ant-input-number-group-addon,
    .ant-input-number-group-wrapper-disabled .ant-input-number-group-addon {
        color: var(--foreground) !important;
        opacity: 0.85 !important;
    }

    .modal-date-picker .ant-picker-suffix,
    .modal-date-picker .ant-picker-clear {
        color: ${mutedForeground} !important;
    }

    .modal-date-picker.ant-picker:hover,
    .ant-picker.modal-date-picker:hover {
        border-color: ${primaryColor} !important;
    }

    .modal-date-picker.ant-picker-focused,
    .ant-picker.modal-date-picker-focused {
        border-color: ${primaryColor} !important;
        box-shadow: 0 0 0 3px rgba(43, 127, 255, 0.12) !important;
    }

    .ant-select-selector {
        overflow-x: auto;
    }

    .ant-select-selection-placeholder {
        color: ${textColorDark} !important;
        font-size: 14px;
    }

    /* Стили для DatePicker в модальном окне фильтров (для всех размеров экрана) */
    .mobile-date-picker-wrapper .mobile-date-picker,
    .mobile-date-picker-wrapper .mobile-date-picker.ant-picker,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker {
        width: 100% !important;
        border-radius: 12px !important;
        border: 1px solid ${borderColor} !important;
        height: 44px !important;
        font-size: 16px !important;
        line-height: 1.2 !important;
        padding: 0 !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-input {
        font-size: 16px !important;
        height: 44px !important;
        line-height: 1.2 !important;
        padding: 0 !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input > input,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-input > input {
        font-size: 16px !important;
        height: 44px !important;
        padding: 0 14px !important;
        line-height: 1.2 !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input > input::placeholder,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-input > input::placeholder {
        font-size: 16px !important;
        color: ${mutedForeground} !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-separator,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-separator {
        font-size: 16px !important;
        margin: 0 8px !important;
        color: ${textColorDark} !important;
        line-height: 1.2 !important;
        height: 44px !important;
        display: flex !important;
        align-items: center !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-suffix,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-suffix {
        font-size: 16px !important;
        color: ${mutedForeground} !important;
        height: 44px !important;
        display: none !important;
        align-items: center !important;
        padding-right: 12px !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear {
        font-size: 16px !important;
        opacity: 1 !important;
        visibility: visible !important;
        display: flex !important;
        align-items: center !important;
        height: 44px !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear-icon,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear-icon {
        opacity: 1 !important;
        visibility: visible !important;
        display: inline-block !important;
    }

    /* Переопределяем hover стили для мобильных устройств */
    .mobile-date-picker-wrapper .mobile-date-picker:hover .ant-picker-clear,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker:hover .ant-picker-clear {
        opacity: 1 !important;
        visibility: visible !important;
    }

    .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear:hover,
    .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear:hover {
        opacity: 0.8 !important;
    }

    /* Стили для кнопки фильтров в заголовке на мобильной версии */
    .mobile-filter-button {
        display: none !important;
    }

    /* Скрываем badge на десктопе */
    .ant-badge:has(.mobile-filter-button) {
        display: none !important;
    }

    .desktop-search {
        display: flex !important;
    }

    @media (max-width: 1200px) {
        .mobile-filter-button {
            display: block !important;
        }

        /* Показываем badge на мобильной версии */
        .ant-badge:has(.mobile-filter-button) {
            display: inline-block !important;
        }

        /* Стили для badge на кнопке фильтров */
        .mobile-filter-button + .ant-badge,
        .ant-badge .mobile-filter-button {
            position: relative;
        }

        .ant-badge-count {
            min-width: 18px !important;
            height: 18px !important;
            line-height: 18px !important;
            font-size: 11px !important;
            padding: 0 5px !important;
            box-shadow: 0 0 0 1px var(--card) !important;
        }

        .desktop-filter-button {
            display: none !important;
        }

        /* Скрываем пагинацию на мобильной версии */
        .desktop-pagination {
            display: none !important;
        }

        .mobile-search {
            display: flex !important;
            width: auto !important;
            flex: 1 !important;
            min-width: 180px !important;
            margin-right: 10px !important;
        }

        .mobile-search input {
            height: 40px !important;
            font-size: 14px !important;
            padding: 10px 12px 10px 40px !important;
        }

        /* Стили для кнопки Фильтры на мобильной версии */
        #transaction-filters-mobile-replacement {
            height: 40px !important;
            min-width: 100px !important;
            padding: 0 20px !important;
            font-size: 14px !important;
        }

        .desktop-search {
            display: none !important;
        }
    }

    @media (max-width: 575px) {
        select#button-options {
            font-size: 16px !important;
        }
        
        select#button-options option {
            padding: 16px 20px !important;
            font-size: 16px !important;
            min-height: 48px !important;
            line-height: 1.5 !important;
            background-color: var(--card) !important;
        }
        
        /* Стили для select в модальном окне фильтров */
        select[id*="filter"] {
            font-size: 16px !important;
        }
        
        select[id*="filter"] option {
            padding: 16px 20px !important;
            font-size: 16px !important;
            min-height: 48px !important;
            line-height: 1.5 !important;
            background-color: var(--card) !important;
        }

        /* Стили для DatePicker в модальном окне фильтров */
        .mobile-date-picker-wrapper .mobile-date-picker,
        .mobile-date-picker-wrapper .mobile-date-picker.ant-picker,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker {
            width: 100% !important;
            border-radius: 12px !important;
            border: 1px solid ${borderColor} !important;
            height: 48px !important;
            font-size: 16px !important;
            line-height: 1.5 !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-input {
            font-size: 16px !important;
            height: 100% !important;
            line-height: 1.5 !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input > input,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-input > input {
            font-size: 16px !important;
            height: 46px !important;
            padding: 12px 14px !important;
            line-height: 1.5 !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input > input::placeholder,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-input > input::placeholder {
            font-size: 16px !important;
            color: ${mutedForeground} !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-separator,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-separator {
            font-size: 16px !important;
            margin: 0 8px !important;
            color: ${textColorDark} !important;
            line-height: 1.5 !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-suffix,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-suffix {
            font-size: 18px !important;
            color: ${mutedForeground} !important;
            display: none !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear {
            font-size: 16px !important;
            opacity: 1 !important;
            visibility: visible !important;
            display: flex !important;
            align-items: center !important;
            height: 44px !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear-icon,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear-icon {
            opacity: 1 !important;
            visibility: visible !important;
            display: inline-block !important;
        }

        /* Переопределяем hover стили для мобильных устройств */
        .mobile-date-picker-wrapper .mobile-date-picker:hover .ant-picker-clear,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker:hover .ant-picker-clear {
            opacity: 1 !important;
            visibility: visible !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear:hover,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear:hover {
            opacity: 0.8 !important;
        }

        /* Календарь для мобильной версии */
        .mobile-date-picker-popup.ant-picker-dropdown,
        .mobile-date-picker-popup .ant-picker-dropdown {
            width: 100vw !important;
            max-width: 100vw !important;
            left: 0 !important;
            right: 0 !important;
            margin: 0 auto !important;
            transform: none !important;
            position: fixed !important;
        }

        .mobile-date-picker-popup .ant-picker-panel-container {
            width: 100% !important;
            margin: 0 auto !important;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
        }

        .mobile-date-picker-popup .ant-picker-panel {
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 auto !important;
        }

        .mobile-date-picker-popup .ant-picker-date-panel {
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 auto !important;
        }

        .mobile-date-picker-popup .ant-picker-cell {
            min-height: 48px !important;
            line-height: 48px !important;
            font-size: 16px !important;
        }

        .mobile-date-picker-popup .ant-picker-header {
            font-size: 18px !important;
            padding: 16px !important;
        }

        .mobile-date-picker-popup .ant-picker-header-view {
            font-size: 18px !important;
        }

        .mobile-date-picker-popup .ant-picker-month-btn,
        .mobile-date-picker-popup .ant-picker-year-btn {
            font-size: 18px !important;
            padding: 8px 12px !important;
        }
    }

    /* Стили для DatePicker в модальном окне фильтров для планшетов */
    @media (min-width: 576px) and (max-width: 1200px) {
        .mobile-date-picker-wrapper .mobile-date-picker,
        .mobile-date-picker-wrapper .mobile-date-picker.ant-picker {
            width: 100% !important;
            border-radius: 12px !important;
            border: 1px solid ${borderColor} !important;
            height: 44px !important;
            font-size: 16px !important;
            line-height: 1.2 !important;
            padding: 0 !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input {
            font-size: 16px !important;
            height: 44px !important;
            line-height: 1.2 !important;
            padding: 0 !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input > input {
            font-size: 16px !important;
            height: 44px !important;
            padding: 0 14px !important;
            line-height: 1.2 !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-input > input::placeholder {
            font-size: 16px !important;
            color: ${mutedForeground} !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-separator {
            font-size: 16px !important;
            margin: 0 8px !important;
            color: ${textColorDark} !important;
            line-height: 1.2 !important;
            height: 44px !important;
            display: flex !important;
            align-items: center !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-suffix {
            font-size: 16px !important;
            color: ${mutedForeground} !important;
            height: 44px !important;
            display: none !important;
            align-items: center !important;
            padding-right: 12px !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear {
            font-size: 16px !important;
            opacity: 1 !important;
            visibility: visible !important;
            display: flex !important;
            align-items: center !important;
            height: 44px !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear-icon,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear-icon {
            opacity: 1 !important;
            visibility: visible !important;
            display: inline-block !important;
        }

        /* Переопределяем hover стили для планшетов */
        .mobile-date-picker-wrapper .mobile-date-picker:hover .ant-picker-clear,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker:hover .ant-picker-clear {
            opacity: 1 !important;
            visibility: visible !important;
        }

        .mobile-date-picker-wrapper .mobile-date-picker .ant-picker-clear:hover,
        .mobile-date-picker-wrapper .ant-picker.mobile-date-picker .ant-picker-clear:hover {
            opacity: 0.8 !important;
        }

        .mobile-date-picker .ant-picker-cell {
            min-height: 44px !important;
            line-height: 44px !important;
            font-size: 15px !important;
        }

        .mobile-date-picker .ant-picker-header {
            font-size: 17px !important;
            padding: 14px !important;
        }

        .mobile-date-picker .ant-picker-header-view {
            font-size: 17px !important;
        }

        .mobile-date-picker .ant-picker-month-btn,
        .mobile-date-picker .ant-picker-year-btn {
            font-size: 17px !important;
            padding: 6px 10px !important;
        }
    }

    /* Стили для модального окна фильтров на мобильной версии */
    @media (max-width: 1200px) {
        #modal-body .filters-content {
            max-height: calc(100dvh - 250px) !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
        }

        #modal-body .filters-buttons {
            position: sticky !important;
            bottom: 0 !important;
            background: var(--card) !important;
            z-index: 10 !important;
            margin-top: auto !important;
        }

        /* Стили для модального окна деталей транзакции на мобильной версии */
        /* Когда внутри есть transaction-details-wrapper, делаем ModalBody flex-контейнером */
        #modal-body:has(.transaction-details-wrapper) {
            display: flex !important;
            flex-direction: column !important;
            overflow: hidden !important;
            height: calc(100dvh - 60px) !important;
            max-height: calc(100dvh - 60px) !important;
        }

        #modal-body .transaction-details-wrapper {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
            min-height: 0 !important;
        }

        #modal-body .transaction-details-content {
            flex: 1 !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
            min-height: 0 !important;
            max-height: none !important;
        }

        #modal-body .transaction-details-buttons {
            flex-shrink: 0 !important;
            background: var(--card) !important;
            z-index: 10 !important;
        }

        /* Стили для модального окна продуктов транзакции на мобильной версии */
        #modal-body:has(.transaction-products-wrapper) {
            display: flex !important;
            flex-direction: column !important;
            overflow: hidden !important;
            height: calc(100dvh - 60px) !important;
            max-height: calc(100dvh - 60px) !important;
        }

        #modal-body .transaction-products-wrapper {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
            min-height: 0 !important;
        }

        #modal-body .transaction-products-content {
            flex: 1 !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
            min-height: 0 !important;
            max-height: none !important;
        }

        /* Стили для модального окна изменения статуса на мобильной версии */
        #modal-body:has(.change-status-wrapper) {
            display: flex !important;
            flex-direction: column !important;
            overflow: hidden !important;
            height: calc(100dvh - 60px) !important;
            max-height: calc(100dvh - 60px) !important;
        }

        #modal-body .change-status-wrapper {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
            min-height: 0 !important;
        }

        #modal-body .change-status-content {
            flex: 1 !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
            min-height: 0 !important;
            max-height: none !important;
        }

        #modal-body .change-status-buttons {
            flex-shrink: 0 !important;
            background: var(--card) !important;
            z-index: 10 !important;
        }

        /* Стили для модального окна создания операции (шаг 1) на мобильной версии */
        #modal-body:has(.create-operation-step1-wrapper) {
            display: flex !important;
            flex-direction: column !important;
            overflow: hidden !important;
            height: calc(100dvh - 60px) !important;
            max-height: calc(100dvh - 60px) !important;
        }

        #modal-body .create-operation-step1-wrapper {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
        }

        #modal-body .create-operation-step1-content {
            flex: 1 !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
            min-height: 0 !important;
            max-height: none !important;
        }

        #modal-body .create-operation-step1-buttons {
            flex-shrink: 0 !important;
            background: var(--card) !important;
            z-index: 10 !important;
            position: sticky !important;
            bottom: 0 !important;
        }

        /* Стили для модального окна создания операции (шаг 2) на мобильной версии */
        #modal-body:has(.create-operation-step2-wrapper) {
            display: flex !important;
            flex-direction: column !important;
            overflow: hidden !important;
            height: calc(100dvh - 60px) !important;
            max-height: calc(100dvh - 60px) !important;
        }

        #modal-body .create-operation-step2-wrapper {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
            overflow: visible !important;
        }
        
        .create-operation-step2-tabs {
            position: sticky !important;
            top: 0 !important;
            background: var(--card) !important;
            z-index: 10 !important;
        }

        #modal-body .create-operation-step2-content {
            flex: 1 !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
            min-height: 0 !important;
            max-height: none !important;
        }

        #modal-body .create-operation-step2-buttons {
            flex-shrink: 0 !important;
            background: var(--card) !important;
            z-index: 10 !important;
            position: sticky !important;
            bottom: 0 !important;
            padding: 15px 16px !important;
        }

        /* Отступ между анимацией загрузки и текстом в кнопке подтверждения */
        .create-operation-step2-buttons .submit-loading-button:before {
            margin-right: 8px !important;
        }

        /* Стили для табов во втором шаге создания операции */
        .create-operation-step2-wrapper .ant-tabs {
            width: 100% !important;
        }

        .create-operation-step2-wrapper .ant-tabs-tab {
            font-size: 16px !important;
            font-weight: 600 !important;
            padding: 12px 24px !important;
            min-width: 120px !important;
            text-align: center !important;
        }

        .create-operation-step2-wrapper .ant-tabs-tab-btn {
            font-size: 16px !important;
            font-weight: 600 !important;
        }

        .create-operation-step2-wrapper .ant-tabs-tab-active .ant-tabs-tab-btn {
            color: ${primaryColor} !important;
            font-weight: 700 !important;
        }

        .create-operation-step2-wrapper .ant-tabs-ink-bar {
            background: ${primaryColor} !important;
            height: 3px !important;
        }

        .create-operation-step2-wrapper .ant-tabs-nav {
            margin-bottom: 0 !important;
            position: sticky !important;
            top: 0 !important;
            background: var(--card) !important;
            z-index: 10 !important;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }

        /* Стили для плавающей кнопки (FAB) добавления товара/услуги */
        .create-operation-step2-wrapper .fab-button {
            position: fixed !important;
            bottom: 180px !important;
            right: 16px !important;
            width: 56px !important;
            height: 56px !important;
            border-radius: 50% !important;
            z-index: 1000 !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        }

        /* Убираем границы у InputLayout в первом шаге создания операции */
        .create-operation-step1-wrapper .InputLayout,
        .create-operation-step1-content .InputLayout {
            border: none !important;
            background: transparent !important;
            border-radius: 0 !important;
        }

        /* Стили для Ant Design компонентов в первом шаге создания операции */
        .create-operation-step1-wrapper .ant-select,
        .create-operation-step1-content .ant-select {
            height: 48px !important;
            width: 100% !important;
            border: none !important;
        }

        /* Стили для всех Select в первом шаге (включая borderless) */
        .create-operation-step1-wrapper .ant-select-selector,
        .create-operation-step1-content .ant-select-selector {
            height: 48px !important;
            min-height: 48px !important;
            font-size: 16px !important;
            border-radius: 8px !important;
            border: 1px solid ${borderColor} !important;
            background-color: var(--card) !important;
            padding: 0 11px !important;
            box-shadow: none !important;
        }

        /* Переопределяем borderless стили для первого шага */
        .create-operation-step1-wrapper .ant-select-borderless .ant-select-selector,
        .create-operation-step1-content .ant-select-borderless .ant-select-selector {
            border: 1px solid ${borderColor} !important;
            background-color: var(--card) !important;
            box-shadow: none !important;
        }

        .create-operation-step1-wrapper .ant-select-selection-item,
        .create-operation-step1-content .ant-select-selection-item,
        .create-operation-step1-wrapper .ant-select-selection-placeholder,
        .create-operation-step1-content .ant-select-selection-placeholder {
            line-height: 46px !important;
            font-size: 16px !important;
            height: 46px !important;
        }

        .create-operation-step1-wrapper .ant-select-selection-search,
        .create-operation-step1-content .ant-select-selection-search {
            line-height: 46px !important;
        }

        .create-operation-step1-wrapper .ant-select-selection-search-input,
        .create-operation-step1-content .ant-select-selection-search-input {
            height: 46px !important;
            line-height: 46px !important;
        }

        .create-operation-step1-wrapper .ant-select-focused .ant-select-selector,
        .create-operation-step1-content .ant-select-focused .ant-select-selector {
            border-color: ${borderColor} !important;
            box-shadow: none !important;
        }

        .create-operation-step1-wrapper .ant-select:hover .ant-select-selector,
        .create-operation-step1-content .ant-select:hover .ant-select-selector {
            border-color: ${borderColor} !important;
        }

        .create-operation-step1-wrapper .ant-input,
        .create-operation-step1-content .ant-input {
            height: 48px !important;
            font-size: 16px !important;
            border-radius: 8px !important;
            padding: 0 12px !important;
            border: 1px solid ${borderColor} !important;
            box-shadow: none !important;
        }

        /* Убираем border с родительского элемента AntSelect (inputStyles) */
        .create-operation-step1-wrapper .ant-select.ant-select-single,
        .create-operation-step1-content .ant-select.ant-select-single {
            border: none !important;
        }

        .create-operation-step1-wrapper .ant-input:focus,
        .create-operation-step1-content .ant-input:focus,
        .create-operation-step1-wrapper .ant-input-focused,
        .create-operation-step1-content .ant-input-focused {
            border-color: ${borderColor} !important;
            box-shadow: none !important;
        }

        .create-operation-step1-wrapper .ant-picker,
        .create-operation-step1-content .ant-picker {
            height: 48px !important;
            font-size: 16px !important;
            border-radius: 8px !important;
            border: 1px solid ${borderColor} !important;
            box-shadow: none !important;
        }

        .create-operation-step1-wrapper .ant-picker-focused,
        .create-operation-step1-content .ant-picker-focused {
            border-color: ${borderColor} !important;
            box-shadow: none !important;
        }

        .create-operation-step1-wrapper .ant-picker-input > input,
        .create-operation-step1-content .ant-picker-input > input {
            font-size: 16px !important;
            height: 46px !important;
        }

        /* Стили для модального окна редактирования товара/услуги */
        #modal-body:has(.product-details-mobile-wrapper) {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
        }

        #modal-body .product-details-mobile-wrapper {
            display: flex !important;
            flex-direction: column !important;
            height: 100% !important;
        }

        /* Стили для Ant Design компонентов в модальном окне редактирования товара/услуги */
        .product-details-mobile-wrapper .ant-input {
            height: 48px !important;
            font-size: 16px !important;
            border-radius: 8px !important;
            padding: 0 12px !important;
            border: 1px solid ${borderColor} !important;
            box-shadow: none !important;
        }

        .product-details-mobile-wrapper .ant-input:focus,
        .product-details-mobile-wrapper .ant-input-focused {
            border-color: ${borderColor} !important;
            box-shadow: none !important;
        }

        .product-details-mobile-wrapper .ant-select {
            height: 48px !important;
            width: 100% !important;
            border: none !important;
        }

        .product-details-mobile-wrapper .ant-select-selector {
            height: 48px !important;
            min-height: 48px !important;
            font-size: 16px !important;
            border-radius: 8px !important;
            border: 1px solid ${borderColor} !important;
            background-color: var(--card) !important;
            padding: 0 11px !important;
            box-shadow: none !important;
        }

        .product-details-mobile-wrapper .ant-select-selection-item,
        .product-details-mobile-wrapper .ant-select-selection-placeholder {
            line-height: 46px !important;
            font-size: 16px !important;
            height: 46px !important;
        }

        .product-details-mobile-wrapper .ant-select-focused .ant-select-selector {
            border-color: ${borderColor} !important;
            box-shadow: none !important;
        }

        .product-details-mobile-wrapper .ant-select:hover .ant-select-selector {
            border-color: ${borderColor} !important;
        }
    }

    @media print {
        display: block;
        body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            display: block;
        }
        .page-break {
            page-break-before: always;
            display: block;
        }

        table {
            page-break-inside: auto;
        }

        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }

        thead {
            display: table-header-group;
        }

        tfoot {
            display: table-footer-group;
        }
    }
`;
